import { FieldConfig, useField } from 'formik';
import React from 'react';
import { Field, FieldProps, PasswordField } from 'ui';

type Props = Omit<FieldProps, 'name'> &
  Omit<FieldConfig, 'value'> & {
    ref?: React.RefObject<HTMLInputElement>;
  };

export function FormikField({ children, name, ...props }: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <Field {...props} {...field} error={meta.error} name={name}>
      {children}
    </Field>
  );
}

export function FormikPasswordField({ children, name, ...props }: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <PasswordField {...props} {...field} error={meta.error} name={name}>
      {children}
    </PasswordField>
  );
}
